import { render, staticRenderFns } from "./TrocarAcomodacao.vue?vue&type=template&id=267f9bda&scoped=true&"
import script from "./TrocarAcomodacao.vue?vue&type=script&lang=js&"
export * from "./TrocarAcomodacao.vue?vue&type=script&lang=js&"
import style0 from "./TrocarAcomodacao.vue?vue&type=style&index=0&id=267f9bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f9bda",
  null
  
)

export default component.exports